import { render, staticRenderFns } from "./PersistentVolume.vue?vue&type=template&id=1ab9582e&"
import script from "./PersistentVolume.vue?vue&type=script&lang=js&"
export * from "./PersistentVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports